import React, { type HTMLAttributes } from 'react';
import { css } from 'styled-components';
import { IconCircleInfoSolid } from '@/app/common/icons/libraryIcons';
import { useTranslation } from '@/app/components/translations/Translation';
import Message from '@/app/components/hotel-detail/Message';
import { Text } from '@lmn/design-system';

const MessageIcon = () => (
  <IconCircleInfoSolid
    css={css`
      color: ${({ theme }) => theme.kallisto.color.icon.static.iconWarning};
    `}
  />
);

type DestinationWithoutAirportMessageProps = {
  destination: string;
} & HTMLAttributes<HTMLElement>;

export default function DestinationWithoutAirportMessage(props: DestinationWithoutAirportMessageProps) {
  const { destination, ...rest } = props;
  const { t } = useTranslation();

  return (
    <Message
      {...rest}
      icon={MessageIcon}
      isDismissable={false}
      css={css`
        background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundWarningSubtle};
        border: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderWarningContrast};
      `}
    >
      <Text
        variant="Body"
        css={css`
          color: ${({ theme }) => theme.kallisto.color.text.static.textWarning};
        `}
      >
        {t('vacation.select.flight.message.island_no_airport', { DESTINATION: destination })}
      </Text>
    </Message>
  );
}
